import { render, staticRenderFns } from "./RequestgroupsList.vue?vue&type=template&id=08cd2ce0&scoped=true"
import script from "./RequestgroupsList.vue?vue&type=script&lang=js"
export * from "./RequestgroupsList.vue?vue&type=script&lang=js"
import style0 from "./RequestgroupsList.vue?vue&type=style&index=0&id=08cd2ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd2ce0",
  null
  
)

export default component.exports